import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import type { UndecoratedForm } from '@witmetrics/utils';
import { classes, styles } from './utils';

export type ResultsListProps = {
  results?: UndecoratedForm[];
  onSelect: (id: number) => void;
};

export default function ResultsList({
  results = [],
  onSelect,
}: ResultsListProps) {
  return (
    <List className={classes.list}>
      {results.map(({ id, name, description }) => {
        return (
          <ListItem key={id} disablePadding>
            <ListItemButton
              sx={styles.listItemButton}
              className={classes.listItemButton}
              onClick={() => onSelect(id)}>
              <ListItemText primary={name} secondary={description} />
            </ListItemButton>
          </ListItem>
        );
      })}
    </List>
  );
}
